import { CASE_STUDY_SLUG } from 'common/constants'
import { CaseStudy } from 'types/generated/contentful'
import { SubHeadline } from '../../designsystem/Text'
import NextLink from 'next/link'

interface CaseStudyLogoWallProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string
  caseStudies: CaseStudy[]
  maxDisplayedCaseStudies?: number
}

const CaseStudyLogoWall = ({
  label,
  caseStudies,
  maxDisplayedCaseStudies,
  className,
  ...props
}: CaseStudyLogoWallProps): JSX.Element => {
  return (
    <div
      className={`max-w-1280 mx-auto ${className ? className : ''}`}
      {...props}
    >
      <div className='flex flex-wrap items-center sm:justify-center -mt-6 md:-mt-10 lg:-mt-14'>
        {label && (
          <SubHeadline
            textColor='gray'
            className='pr-6 md:pr-8 lg:pr-10 pt-4 md:pt-6 lg:pt-8'
          >
            {label}
          </SubHeadline>
        )}

        {caseStudies.slice(0, maxDisplayedCaseStudies).map((caseStudy) => {
          const { sys, quote, slug } = caseStudy
          const { company } = quote?.author || {}
          const { logo, name } = quote?.author?.company || {}
          const { url, width, height, title } = logo || {}

          return (
            <NextLink
              href={`${CASE_STUDY_SLUG}/${slug}`}
              key={sys.id}
              aria-label={`Read ${company?.name}'s case study`}
              className='opacity-40 transition-opacity hover:opacity-70 focus:opacity-70 pt-4 md:pt-6 lg:pt-8 pr-6 md:pr-8 lg:pr-10'
            >
              {url && width && height && (
                <img
                  src={url}
                  width={width}
                  height={height}
                  alt={title || `${name} logo` || ''}
                  className='h-8 w-auto'
                />
              )}
            </NextLink>
          )
        })}
      </div>
    </div>
  )
}

export default CaseStudyLogoWall
